import banktranService from '../../services/banktrans'

const state = {
    loading: false,
    errors: null,
    banktrans:[] ,
}

const actions = {
    getAll({ commit }) {
        commit('BANKTRAN_LOADING', true)
        banktranService.getAll().then(
            response => {

                commit('LOAD_BANKTRANS', response.data)
                commit('BANKTRAN_LOADING', false)
                commit('BANKTRAN_FAILURE', null)
            },
            error => {
                commit('BANKTRAN_FAILURE', error)
                commit('BANKTRAN_LOADING', false)
            }
        )
    },
    add({ commit }, data) {
        commit('BANKTRAN_LOADING', true)
        commit('BANKTRAN_FAILURE', null)

        banktranService.add(data).then(
            response => {
                data.id = response.data.id
                data.recorded_by = response.data.recorded_by
                data.bankacc = response.data.bankacc
                commit('ADD_BANKTRAN', data)
                commit('BANKTRAN_LOADING', false)

            },
            error => {
                commit('BANKTRAN_FAILURE', error)
                commit('BANKTRAN_LOADING', false)
            }
        )
    },
    update({ commit }, data) {
        commit('BANKTRAN_LOADING', true)
        commit('BANKTRAN_FAILURE', null)
        data.banktran.roles = "banktran"
        banktranService.update(data.banktran)
            .then(
                response => {
                    commit('UPDATE_BANKTRAN', data)
                    commit('BANKTRAN_LOADING', false)

                },
                error => {
                    commit('BANKTRAN_FAILURE', error)
                    commit('BANKTRAN_LOADING', false)
                }
            )


    },
    delete({ commit }, data) {
        commit('BANKTRAN_LOADING', true)
        commit('BANKTRAN_FAILURE', null)
        banktranService.delete(data.banktran.id)
            .then(
                response => {

                    commit('DELETE_BANKTRAN', data)
                    commit('BANKTRAN_LOADING', false)

                },
                error => {
                    commit('BANKTRAN_FAILURE', error)
                    commit('BANKTRAN_LOADING', false)
                }
            )
    }
}

const mutations = {
    ADD_BANKTRAN(state, payload) {
        state.banktrans.unshift(payload);
    },
    LOAD_BANKTRANS(state, payload) {
        state.banktrans = payload
    },
    UPDATE_BANKTRAN(state, payload) {
        Object.assign(state.banktrans[payload.index], payload.banktran);
    },
    DELETE_BANKTRAN(state, payload) {
        state.banktrans.splice(payload.index, 1)
    },
    BANKTRAN_FAILURE(state, payload) {
        state.errors = payload
    },

    BANKTRAN_LOADING(state, payload) {
        state.loading = payload
    },
}


const getters = {
    BANKTRANS: state => {
        return state.banktrans
    },

    BANKTRAN_ERROR: state => {
        return state.errors
    },

    BANKTRAN_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/banktrans.js